import { manageFiles } from "../modules/api/docListsandDetails";


interface UploadParamsBase {
  clientDbId: number;
  module: string;
  operationCode: string;
  file: string;          
  fileType: string;      
  description?: string;
  locale?: string;
}

interface UploadRowParams extends UploadParamsBase {
  rowNumber: string | number;
}

// Įkėlimas prie dokumento headerio (be rowNumber)
export const uploadFileToHeader = async (params: UploadParamsBase) => {
  return manageFiles({
    clientDbId: params.clientDbId,
    module: params.module,
    operationCode: params.operationCode,
    oper: "I",               
    file: params.file,
    fileType: params.fileType,
    description: params.description,
    locale: params.locale,
  });
};

// Įkėlimas prie konkrečios eilutės (su rowNumber)
export const uploadFileToRow = async (params: UploadRowParams) => {
  return manageFiles({
    clientDbId: params.clientDbId,
    module: params.module,
    operationCode: params.operationCode,
    rowNumber: String(params.rowNumber), 
    oper: "I",               
    file: params.file,
    fileType: params.fileType,
    description: params.description,
    locale: params.locale,
  });
};
